import { Deserializable } from '../../protocols/deserializable';
import { ProfileBadgeConfiguration } from './profile-badge-configuration';

export class InternalUserProfile implements Deserializable {
  public id!: number;
  public firstName!: string;
  public lastName!: string;
  public profileBadgeConfiguration!: ProfileBadgeConfiguration;

  public initials!: string;

  public onDeserialize() {
    this.profileBadgeConfiguration = window.injector.Deserialize.instanceOf(
      ProfileBadgeConfiguration,
      this.profileBadgeConfiguration
    );
    this.initials = `${this.firstName?.charAt(0)}${this.lastName?.charAt(0)}`;
  }
}
